<template>
  <el-tag style="height: auto" :type="getTagType">
    {{ $t('common_words.phone') }}:
    {{ contact.phone ? contact.phone : $t('common_words.no_assignment') }}
    <br />
    {{ $t('common_words.email') }}:
    {{ contact.email ? contact.email : $t('common_words.no_assignment') }}
    <br />
    {{ $t('inventory.email_type') }}:
    <div
      v-if="
        contact.provider_type_email && contact.provider_type_email.length > 0
      "
    >
      <div
        v-for="(emailType, index) in contact.provider_type_email"
        :key="index"
      >
        <el-tag size="mini">{{ emailType.type }}</el-tag>
      </div>
    </div>
    <div v-else>
      <el-tag size="mini">{{ $t('common_words.no_assignment') }}</el-tag>
    </div>
    <br />
  </el-tag>
</template>
<script>
export default {
  name: 'contacts-tag',
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getTagType() {
      return this.contact.deleted_at ? `danger` : `info`;
    },
  },
};
</script>
